module.exports = __webpack_public_path__ + "img/main_01.d26f566b.png";